export default "__VITE_ASSET__k$INnUBC__"